const ADMIN_NOTIFICATIONS_ROOM = 'App.User.Admin';

const ADMIN_USER_ID = 'system';

const META_SEPARATOR = '|||';

const ChatType = {
  SUPPORT: {
    id: 1,
    title: 'Admin',
  },

  PRO: {
    id: 2,
    title: 'Pro',
  },
};

ChatType.ID_TO_DATA = {
  [ChatType.SUPPORT.id]: ChatType.SUPPORT,
  [ChatType.PRO.id]: ChatType.PRO,
};

ChatType.LIST = [
  ChatType.SUPPORT,
  ChatType.PRO,
];

const MessageState = {
  SENDING: {
    id: 1,
    title: 'Sending',
  },

  SENT: {
    id: 2,
    title: 'Sent',
  },

  READ: {
    id: 3,
    title: 'Read',
  },
};

MessageState.ID_TO_DATA = {
  [MessageState.SENDING.id]: MessageState.SENDING,
  [MessageState.SENT.id]: MessageState.SENT,
  [MessageState.READ.id]: MessageState.READ,
};

const Events = {
  UNAUTHORIZED: 'unauthorized request',
  JOINED: 'joined',
  JOIN: 'join',
  LEAVE: 'leave',
  LEAVED: 'leaved',
  MESSAGE_STATE: 'messageState',
  MESSAGE: 'message',
  NEW_MESSAGE: 'new_message',
  CONNECT_DATA: 'connectData',
  HANDSHAKE: 'handshake',
  RECONNECT: 'reconnect',
  DISCONNECT: 'disconnect',
  DISCONNECTED: 'disconnected',
  CONNECT_ERROR: 'connect_error',
  GET_HISTORY: 'getHistory',
  HISTORY: 'history',
  USERS_LIST: 'usersList',
  FORBIDDEN: 'forbidden',
  SHUTDOWN: 'shutdown',
  // USER_STATUS: 'userStatus',
  GET_USERS_IN_ROOM: 'getUsersInRoom',
};

const SystemMessageType = {
  NEW_EXECUTOR: {
    id: 1,
    text: ({ culpritId, oldExecutorId, newExecutorId }, customer) => {
      /* eslint-disable max-len */
      if (newExecutorId) {
        return `Your pro was changed to ${newExecutorId}`; // TODO надо заменить id на ник
      }

      // Если про виновен в смене
      if (+culpritId === +oldExecutorId) {
        return 'For a reason that you can clarify in the support chat, we are looking for new pro for you, sorry for this situation, personal or technical problems sometimes happen, thanks for your understanding';
      }

      // Если клиент
      if (+culpritId === +customer.id) {
        return 'At your request or for a reason that you can clarify in the support chat, we are looking for new pro for you';
      }

      // Если менеджер
      return 'Unfortunately supports are people too and we are mistaken (you can clarify via chat, if you are interested), sorry for this situation, we are looking new pro for your order';
      /* eslint-enable max-len */
    },
  },
};

SystemMessageType.ID_TO_DATA = {
  [SystemMessageType.NEW_EXECUTOR.id]: SystemMessageType.NEW_EXECUTOR,
};

/* eslint-disable max-len */
const Alerts = {
  IS_FINISHED: { text: 'Order’s completed, chat’s now closed &nbsp;☝️', isClosable: false, isVisible: true },
  IS_CONNECTION_ERROR: { text: 'Chat temporary in readonly mode. We know about this technical problem and solving the issue right now. Sorry for inconvenience.', isClosable: false, isVisible: true },
  NO_CHAT: { text: 'Hello, unfortunately there will be no chat in the orders you made before, contact the support via site if you have any questions about this order!', isClosable: false, isVisible: true },
  DISABLED_CHAT_CLIENT: { text: 'This pro does not speak English well, so for better communication please write to us via support chat in the lower right corner, thanks for understanding.', isClosable: false, isVisible: true },
  CLIENT_WARNING_A: { text: 'Please report any attempts by PROs to sell outside the platform and earn a $100-1000 bonus.', isClosable: true, isVisible: true },
  CLIENT_WARNING_B: { text: 'Please report if a PRO doesn\'t remove your in-game contact after completing an order and get a $10-100 bonus.', isClosable: true, isVisible: true },
  PRO_WARNING: {
    text: 'Selling to our clients outside the platform or contacting them in any messenger other than this chat will result in a PERMANENT BAN.\n'
      + 'Not removing a client\'s in-game contacts after completing an order will result in a $10-100 fine.\n'
      + 'If you notice someone selling to our clients outside the platform, please report it for a $100-1000 bonus.',
    isClosable: true,
    isVisible: true,
  },
};
/* eslint-enable max-len */

const CLOSED_CHAT_ALERTS_ORDER_IDS_KEY = 'closedChatAlertsOrderIds';

export {
  ADMIN_NOTIFICATIONS_ROOM,
  ADMIN_USER_ID,
  META_SEPARATOR,
  ChatType,
  MessageState,
  Events,
  SystemMessageType,
  Alerts,
  CLOSED_CHAT_ALERTS_ORDER_IDS_KEY,
};
